import postAPI from './postAPI.js'

export default async function postCheckStepSigning(body) {
    const data = await postAPI('taskinstances/steps/signing/check', body);
    return data;
}
